import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";

export interface YesNoModalProps {
    title?: string;
    message: string;
    isOpen: boolean;
    onYes: () => void;
    toggle: () => void;
}

export class YesNoModal extends React.Component<YesNoModalProps> {
    private handleClick(fnc: () => void, event: React.SyntheticEvent<HTMLAnchorElement>) {
        event.preventDefault();

        fnc();
    }

    public render() {
        const { title, message, isOpen, onYes, toggle } = this.props;

        return (
            <Modal isOpen={isOpen} toggle={toggle}>
                {title != null &&
                    <ModalHeader>{title}</ModalHeader>
                }
                <ModalBody>
                    {message}
                </ModalBody>
                <ModalFooter>
                    <Button tag="a" href="#" color="primary"
                        onClick={this.handleClick.bind(this, onYes)}>
                        <FormattedMessage id="ui.button.yes" defaultMessage="Yes" />
                    </Button>
                    {" "}
                    <Button tag="a" href="#" color="secondary"
                        onClick={this.handleClick.bind(this, toggle)}>
                        <FormattedMessage id="ui.button.no" defaultMessage="No" />
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
